// tslint:disable-next-line:only-arrow-functions
export function nameof<T>(name: keyof T): keyof T {
  return name;
}
